export const UI_FETCHING = 'UI_FETCHING' as const
export const UI_FETCHED = 'UI_FETCHED' as const

export const UI_TOAST_DISPLAY_INFO = 'UI_TOAST_DISPLAY_INFO' as const
export const UI_TOAST_DISPLAY_WARNING = 'UI_TOAST_DISPLAY_WARNING' as const
export const UI_TOAST_DISPLAY_ERROR = 'UI_TOAST_DISPLAY_ERROR' as const
export const UI_TOAST_REMOVE = 'UI_TOAST_REMOVE' as const
